import { DsCompanyLotInterface } from '../interfaces/ds-company-lot.interface';

export class DsCompanyLotModel {
  /**
   * Id of the lot.
   */
  public id?: number;

  /**
   * Name of the lot.
   */
  public name?: string;

  /**
   * Id of the creator of the lot.
   */
  public createdBy?: number;

  /**
   * Creation date of the lot.
   */
  public createdDate?: number;

  /**
   * Creates an instance of DsCompanyLotModel.
   *
   * @param lot New lot.
   */
  constructor(lot: DsCompanyLotInterface) {
    this.id = lot.id;
    this.name = lot.name;
    this.createdBy = lot.createdBy;
    this.createdDate = lot.createdDate;
  }
}
